import request from '@/lib/request'
import { DEFAULT_REG_CHANNEL } from '@/config'


/***
 * 登录,如果用户不存在则创建用户，最终返回AccessToken&RefreshToken
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function login(params = {}) {
  return request.post('/api/v1/rental/member/login', {
    "code": params.code,
    "mobile": params.mobile,
    "regChannel": params.regChannel || DEFAULT_REG_CHANNEL,
  }, {
    _reqLogin: false
  });
}

/***
 * 登出,删除AccessToken&RefreshToken
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function logout(params = {}) {
  return request.post('/api/v1/rental/member/logout', {
    "refreshToken": params.refreshToken
  }, {
    _reqLogin: false
  });
}

/***
 * 刷新AccessToken,同时返回新的RefreshToken
 * @param params
 * @returns {Promise | Promise<unknown>}
 * @private
 */
export function refresh(params = {}) {
  return request.post('/api/v1/rental/member/refresh', {
    "refreshToken": params.refreshToken
  }, {
    _reqLogin: false
  });
}

/**
 * 获取当前登录会员信息及 KYC/OCR 核验状态
 */
export function getMemberInfo(config = {}) {
  return request.get('/api/v1/rental/member/info', {}, config);
}

/**
 * 注销当前会员账号。
 */
export function cancelMember(params = {}) {
  return request.post('/api/v1/rental/member/cancel', {
    "code": params.code
  });
}
